var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.18605 10.0591C4.18605 9.42274 4.27907 8.78637 4.51163 8.19546L1.06977 5.60455C0.372093 6.96819 0 8.46819 0 10.0591C0 11.65 0.372093 13.15 1.06977 14.4682L4.51163 11.8773C4.27907 11.3318 4.18605 10.6955 4.18605 10.0591Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06982 5.64999L4.51168 8.2409C5.30238 5.83181 7.53494 4.14999 10.2326 4.14999C11.6745 4.14999 12.9768 4.64999 14.0001 5.46817L16.9768 2.55908C15.1628 1.01363 12.8373 0.059082 10.2326 0.059082C6.1861 0.059082 2.69773 2.33181 1.06982 5.64999Z",
    fill: "#EA4335"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2326 8.24091V12.1045H15.721C15.2094 14.5591 13.0698 15.9682 10.2326 15.9682C7.53494 15.9682 5.30238 14.2864 4.51168 11.9227L1.06982 14.5136C2.69773 17.7864 6.1861 20.0591 10.2326 20.0591C15.3489 20.0591 20.0001 16.4227 20.0001 10.0591C20.0001 9.46818 19.907 8.83181 19.7675 8.24091H10.2326Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2327 8.24091V12.1045H15.721C15.442 13.4227 14.6978 14.4227 13.628 15.1045L16.8838 17.5591C18.7443 15.8318 20.0001 13.3318 20.0001 10.0591C20.0001 9.46818 19.9071 8.83181 19.7675 8.24091H10.2327Z",
    fill: "#4285F4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.059082)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.1885109a91d85e9e473ba5a102aec089.svg";
export { ForwardRef as ReactComponent };